import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  '& .IRSSectionContainer': {
    position: 'relative',
    left: 'calc((100vw - 100%) / -2)', // Negative margin to pull left
    width: 'calc(100vw)', // Extend to full viewport width
    overflow: 'hidden',
    paddingLeft: 'calc((100vw - 100%) / 2)',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 3),
    },
  },
  '& .IRSubTitle': {
    maxWidth: theme.typography.pxToRem(740),
    color: theme.palette.text.secondary,
  },
}));

export default StyledBox;
